import { Patient } from '@/models/Patient';

export const defaultPatient = new Patient({
  age: 0,
  ageUnit: 'years',
  height: 0,
  heightUnit: 'cm',
  weight: 0,
  weightUnit: 'kg',
  gender: null,
  dialysis: false,
});

export const samplePatient = {
  id: 'SAMPLE',
  modelId: 'BUEL2005',
  description: 'Vancomycin BUEL2005 Male 64y',
  patient: new Patient({
    id: null,
    age: 64,
    ageUnit: 'years',
    height: 180,
    heightUnit: 'cm',
    weight: 100,
    weightUnit: 'kg',
    gender: 'Male',
  }),
  delivery: {
    method: 'IV',
    interval: 12,
    intervalUnit: 'hours',
    duration: 1.5,
    durationUnit: 'hours',
    daysToDisplay: 3,
  },
  target: {
    target: 'AUC',
    pdtMin: 400,
    pdtMax: 600,
    pdtUnit: 'mg·hr/L',
  },
  pathology: {
    pathogen: 'E. coli',
    mic: 1,
    micUnit: 'mcg/mL',
  },
  doses: [], //set these at time of loading
};

export const samplePatientThom2009 = {
  id: 'SAMPLE_THOM',
  modelId: 'THOM2009',
  description: 'Vancomycin THOM2009 Male 64y',
  patient: new Patient({
    id: null,
    age: 64,
    ageUnit: 'years',
    height: 180,
    heightUnit: 'cm',
    weight: 100,
    weightUnit: 'kg',
    gender: 'Male',
  }),
  delivery: {
    method: 'IV',
    interval: 12,
    intervalUnit: 'hours',
    duration: 1,
    durationUnit: 'hours',
    daysToDisplay: 3,
  },
  target: {
    target: 'AUC',
    pdtMin: 400,
    pdtMax: 600,
    pdtUnit: 'mg·hr/L',
  },
  pathology: {
    pathogen: 'E. coli',
    mic: 1,
    micUnit: 'mcg/mL',
  },
  doses: [], //set these at time of loading
};

export const samplePatientGentamicin = {
  id: 'SAMPLE_GENT',
  modelId: 'GENTA_ICU',
  description: 'Gentamicin ICU Male 64y',
  patient: new Patient({
    id: null,
    age: 64,
    ageUnit: 'years',
    height: 180,
    heightUnit: 'cm',
    weight: 100,
    weightUnit: 'kg',
    gender: 'Male',
  }),
  delivery: {
    method: 'IV',
    interval: 24,
    intervalUnit: 'hours',
    duration: 0.5,
    durationUnit: 'hours',
    daysToDisplay: 3,
  },
  target: {
    target: 'Peak',
    pdtMin: 8,
    pdtMax: 12,
    pdtUnit: 'mg/L',
  },
  pathology: {
    pathogen: 'E. coli',
    mic: 0.5,
    micUnit: 'mg/L',
  },
  doses: [],
};

export const samplePatient2Compartment = {
  id: 'SAMPLE2',
  modelId: 'PIP',
  description: 'Piperacillin UDY2015 Male 64y',
  patient: new Patient({
    id: null,
    age: 64,
    ageUnit: 'years',
    height: 180,
    heightUnit: 'cm',
    weight: 100,
    weightUnit: 'kg',
    gender: 'Male',
  }),
  delivery: {
    method: 'IV',
    interval: 6,
    intervalUnit: 'hours',
    duration: 0.3,
    durationUnit: 'hours',
    daysToDisplay: 3,
  },
  target: {
    target: 'fT>MIC',
    pdtMin: 50,
    pdtMax: 100,
    pdtUnit: '%',
  },
  pathology: {
    pathogen: 'E. coli',
    mic: 2,
    micUnit: 'mg/L',
  },
  doses: [], //set these at time of loading
};

export const samplePatientAdan2015 = {
  id: 'SAMPLE_ADAN',
  modelId: 'ADAN2015',
  description: 'Vancomycin ADAN2015 Extremely Obese Male 43y',
  patient: new Patient({
    id: null,
    age: 43,
    ageUnit: 'years',
    height: 175,
    heightUnit: 'cm',
    weight: 148,
    weightUnit: 'kg',
    gender: 'Male',
  }),
  delivery: {
    method: 'IV',
    interval: 12,
    intervalUnit: 'hours',
    duration: 1.5,
    durationUnit: 'hours',
    daysToDisplay: 3,
  },
  target: {
    target: 'AUC',
    pdtMin: 400,
    pdtMax: 600,
    pdtUnit: 'mg·hr/L',
  },
  pathology: {
    pathogen: 'S. aureus',
    mic: 1,
    micUnit: 'mcg/mL',
  },
  doses: [],
};

export const samplePatientMasi2020 = {
  id: 'SAMPLE_MASI',
  modelId: 'MASI2020',
  description: 'Vancomycin MASI2020 Obese Sepsis Male 62y',
  patient: new Patient({
    id: null,
    age: 62,
    ageUnit: 'years',
    height: 170,
    heightUnit: 'cm',
    weight: 113,
    weightUnit: 'kg',
    gender: 'Male',
  }),
  delivery: {
    method: 'IV',
    interval: 12,
    intervalUnit: 'hours',
    duration: 1,
    durationUnit: 'hours',
    daysToDisplay: 3,
  },
  target: {
    target: 'AUC',
    pdtMin: 400,
    pdtMax: 600,
    pdtUnit: 'mg·hr/L',
  },
  pathology: {
    pathogen: 'S. aureus',
    mic: 1,
    micUnit: 'mcg/mL',
  },
  doses: [],
};

export const samplePatientLlop2006 = {
  id: 'SAMPLE_LLOP',
  modelId: 'LLOP2006',
  description: 'Vancomycin LLOP2006 ICU Male 64y',
  patient: new Patient({
    id: null,
    age: 64,
    ageUnit: 'years',
    height: 175,
    heightUnit: 'cm',
    weight: 75,
    weightUnit: 'kg',
    gender: 'Male',
  }),
  delivery: {
    method: 'IV',
    interval: 12,
    intervalUnit: 'hours',
    duration: 1.5,
    durationUnit: 'hours',
    daysToDisplay: 3,
  },
  target: {
    target: 'AUC',
    pdtMin: 400,
    pdtMax: 600,
    pdtUnit: 'mg·hr/L',
  },
  pathology: {
    pathogen: 'E. coli',
    mic: 1,
    micUnit: 'mcg/mL',
  },
  doses: [],
};

export const samplePatientGoti2018 = {
  id: 'SAMPLE_GOTI',
  modelId: 'GOTI2018',
  description: 'Vancomycin GOTI2018 Hospitalized Male 57y',
  patient: new Patient({
    id: null,
    age: 57,
    ageUnit: 'years',
    height: 175,
    heightUnit: 'cm',
    weight: 79,
    weightUnit: 'kg',
    gender: 'Male',
    dialysis: false,
  }),
  delivery: {
    method: 'IV',
    interval: 12,
    intervalUnit: 'hours',
    duration: 1,
    durationUnit: 'hours',
    daysToDisplay: 3,
  },
  target: {
    target: 'AUC',
    pdtMin: 400,
    pdtMax: 600,
    pdtUnit: 'mg·hr/L',
  },
  pathology: {
    pathogen: 'S. aureus',
    mic: 1,
    micUnit: 'mg/L',
  },
  doses: [],
};

export const samplePatientGoti2018Dialysis = {
  id: 'SAMPLE_GOTI_DIAL',
  modelId: 'GOTI2018',
  description: 'Vancomycin GOTI2018 Hemodialysis Male 57y',
  patient: new Patient({
    id: null,
    age: 57,
    ageUnit: 'years',
    height: 175,
    heightUnit: 'cm',
    weight: 79,
    weightUnit: 'kg',
    gender: 'Male',
    dialysis: true,
  }),
  delivery: {
    method: 'IV',
    interval: 48,
    intervalUnit: 'hours',
    duration: 1,
    durationUnit: 'hours',
    daysToDisplay: 6,
  },
  target: {
    target: 'AUC',
    pdtMin: 400,
    pdtMax: 600,
    pdtUnit: 'mg·hr/L',
  },
  pathology: {
    pathogen: 'S. aureus',
    mic: 1,
    micUnit: 'mg/L',
  },
  doses: [],
};
